<template>
    <div class="addFollowUp">
        <div class="key_top">
            <ul class="key_list">
                <li class="conditions_list_item time">
                    <span>跟进时间</span>
                    <el-date-picker v-model="search.followUpDates" @change="currentPage=1,pageNumber=1,queryFollowUpManage()" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </li>
                <li class="conditions_list_item" style="position:relative">
                    <span>跟进人</span>
                    <el-input @focus="departpopshow=!departpopshow" v-model="search.departmentName" placeholder="请选择所在部门" @clear="clearPerson" clearable></el-input>
                    <div class="departpop" v-show="departpopshow">
                        <el-tree :default-expand-all="true" :data="departmentList" :props="defaultProps" @node-click="handleNodeClick">
                            <span class="custom-tree-node" slot-scope="{ node,data}">
                                <div>
                                    <img class="tree-icon" v-if="data.labelName=='区'" src="../../assets/icon/quyu.png" alt />
                                    <img class="tree-icon" v-if="data.labelName=='店'" src="../../assets/icon/dian.png" alt />
                                    <img class="tree-icon" v-if="data.labelName=='组'" src="../../assets/icon/zu.png" alt />
                                    <span>{{ data.name }}</span>
                                </div>
                            </span>
                        </el-tree>
                    </div>
                    <el-select v-model="search.employeeId" @change="currentPage=1,pageNumber=1,queryFollowUpManage()" @clear="clearPerson" placeholder="不限" clearable>
                        <el-option v-for="(item,index) in userList" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </li>
                <li class="conditions_list_item">
                    <span>房源编号</span>
                    <el-input v-model="search.houseCode" @input="currentPage=1,pageNumber=1,queryFollowUpManage()" placeholder="请输入房源编号" clearable></el-input>
                </li>
                <li class="conditions_list_item">
                    <span>客源编号</span>
                    <el-input v-model="search.cusCode" @input="currentPage=1,pageNumber=1,queryFollowUpManage()" placeholder="请输入客源编号" clearable></el-input>
                </li>
                <li class="conditions_list_item">
                    <span>类型</span>
                    <el-select v-model="search.followUpType" @change="currentPage=1,pageNumber=1,queryFollowUpManage()" placeholder="不限" clearable>
                        <el-option v-for="(item,index) in followUpTypeList" :key="index" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </li>
            </ul>
        </div>
        <div class="key_list_wrap sales_list_wrap">
            <el-table :data="List" border style="width: 100%" :header-cell-style="setHeaderStyle" @row-click="rowColorclick" highlight-current-row>
                <el-table-column prop="followUpTime" label="跟进日期"></el-table-column>
                <el-table-column prop="followUpPeople" label="跟进人"></el-table-column>
                <el-table-column prop="followUpType" label="跟进类型"></el-table-column>
                <el-table-column label="房源编号">
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.id===isRowColor}" @click="goHouse(scope.row.houseId,scope.row.houseEmployeeId,scope.row.housingProperty)" style="color:#5e75e6;cursor:pointer;padding:0 20px">{{scope.row.houseCode}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="residentialAreaName" label="小区"></el-table-column>
                <el-table-column label="客源编号">
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.id===isRowColor}" @click="goCustom(scope.row.customerId,scope.row.customerEmployeeId)" style="color:#5e75e6;cursor:pointer;padding:0 20px">{{scope.row.cusCode}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="customerLevel" label="客户等级"></el-table-column>
                <el-table-column prop="followUpContent" label="跟进内容"></el-table-column>
                <el-table-column prop="remind" label="是否有提醒"></el-table-column>
            </el-table>
            <div class="footer_page">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="20" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
import AddKeyAlert from "@/components/common/addKeyAlert";
import {
    queryKey,
    queryFollowUpManage,
    departmentFind,
    employeeQuery
} from "@/api/manageCenter";
import { queryName } from "@/api";
export default {
    // name: "跟进管理",
    name: "/addFollowUp",
    data() {
        let permisList = JSON.parse(sessionStorage.getItem("permisList"));
        return {
            permisList,
            isRowColor: "",
            total: 0,
            currentPage: 1,
            pageNumber: 1, //从第几条开始
            pageSize: 20, //显示条数
            // state: "不限", //状态
            List: [], //跟进列表
            KeyStateList: [], //钥匙状态列表
            followUpTypeList: [
                { name: "不限", value: 0 },
                { name: "房源", value: 1 },
                { name: "客源", value: 2 }
            ],
            departpopshow: false,
            departmentList: [],
            defaultProps: {
                children: "child"
            },
            userList: [],
            //搜索
            search: {
                followUpDates: "", //跟进时间
                enterpriseCode: "",
                departmentId: "", //部门id
                departmentName: "", //部门名字
                cusCode: "", //员工编号
                houseCode: "", //房源编号
                followUpType: "", //跟进类型
                permissionLevel: sessionStorage.getItem("permisListlevel") //权限级别
            }
        };
    },
    components: {},
    mounted() {
        this.queryFollowUpManage();
        this.getdepartmentFindAll();
        this.Getmessage();
        this.isRowColor = ''
    },
    activated() {
        this.queryFollowUpManage();
        this.getdepartmentFindAll();
        this.Getmessage();
        this.isRowColor = ''
    },
    methods: {
        permisShow(data) {
            // 权限配置
            let result = this.permisList.indexOf(data);
            console.log(23432343423, result);
            if (result >= 0) {
                return true;
            } else {
                return false;
            }
        },
        //修改当前行字体颜色
        rowColorclick(row) {
            this.isRowColor = row.id;
        },

        getdepartmentFindAll() {
            // 获取部门
            this.$post(departmentFind).then(res => {
                if (res.success) {
                    this.departmentList = res.data;
                }
            });
        },
        handleNodeClick(node, data) {
            //cosole.log(node)
            this.search.departmentId = node.id;
            this.search.departmentName = node.name;
            this.departpopshow = false;
            this.Getmessage();
            this.queryFollowUpManage();
        },

        Getmessage() {
            var params = {
                departmentId: this.search.departmentId,
                permissionLevel: sessionStorage.getItem("permisListlevel"),
                status:'ENABLE',
            };
            this.$post(employeeQuery, params).then(res => {
                if (res.success === true) {
                    this.userList = res.data;
                }
            });
        },

        queryFollowUpManage() {
            // 获取跟进列表

            let result = this.permisShow("跟进管理");
            if (!result) {
                return false;
            }
            let params = Object.assign({}, this.search);
            params["page.pageNumber"] = (this.pageNumber - 1) * this.pageSize;
            params["page.pageSize"] = this.pageSize;
            this.$post(queryFollowUpManage, params).then(res => {
                if (res.success) {
                    this.List = res.data;
                    this.total = res.total;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        goHouse(id, employeeId, houseSta) {
            if (houseSta == "SECONDHAND") {
                sessionStorage.setItem("sellHousebuildId", id);
                this.$router.push("/buildDetail");
            } else if (houseSta == "RENTING") {
                sessionStorage.setItem("rentHousebuildId", id);
                this.$router.push("/rentingBuildDetail");
            } else if (houseSta == "SHOP_SALE") {
                sessionStorage.setItem("sellShopbuildId", id);
                this.$router.push("/sellShopDetails");
            } else if (houseSta == "SHOP_RENTAL") {
                sessionStorage.setItem("rentShopbuildId", id);
                this.$router.push("/rentShopDetails");
            }
            sessionStorage.setItem("buildId", id);
            sessionStorage.setItem("employeeId", employeeId);
        },

        goCustom(id, employeeId) {
            localStorage.setItem("customerId", id);
            sessionStorage.setItem("employeeId", employeeId);
            this.$router.push("/purchaseDetail");
        },

        clearPerson() {
            this.search.departmentName = "";
            this.search.departmentId = "";
            this.queryFollowUpManage();
        },

        //分页
        handleCurrentChange(val) {
            this.pageNumber = val;
            this.queryFollowUpManage();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.queryFollowUpManage();
        },

        //表单头部颜色
        setHeaderStyle() {
            return "background-color: #F2F4FF";
        }
    }
};
</script>
<style type="text/css" lang="less">
.addFollowUp {
    height: 100%;
    .departpop {
        width: 170px;
        position: absolute;

        left: 60px;
        top: 41px;
        z-index: 10;
        border: 1px solid #eee;
        .tree-item {
            display: flex;
            align-items: center;
            img {
                padding-right: 10px;
            }
        }
    }
    .key_list {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        .conditions_list_item {
            padding: 0 10px;
            display: flex;
            align-items: center;
            margin: 5px 20px 5px 0;
            position: relative;
            // overflow: hidden;
            cursor: pointer;
            > span {
                font-size: 12px;
                color: #666666;
                padding: 4px 10px 4px 0;
            }
            .el-date-editor {
                margin-left: 10px;
                width: 310px;
                height: 30px;
                line-height: 30px;
                border: 1px solid #dbdbdb;
                .el-range__icon {
                    line-height: 25px;
                }
                .el-range-input {
                    // width: 310px;
                    line-height: 30px;
                    height: 28px;
                    border: none;
                    color: black;
                    padding-left: 30px;
                }
                .el-range-separator {
                    line-height: 26px;
                }
            }
            .el-select {
                margin-left: 10px;
                .el-input {
                    width: 80px;

                    .el-input__inner {
                        border: 1px solid #dbdbdb;
                        width: 80px;
                        height: 30px;
                        color: black;
                        padding: 0 5px;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }
            .shop {
                .el-input {
                    width: 100px;
                    .el-input__inner {
                        border: 1px solid #dbdbdb;
                        width: 100px;
                        height: 30px;
                        border: none;
                        color: black;
                        padding: 0;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }
        }
    }

    .key_top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 30px;
        background: #fff;
        .el-input {
            width: 145px;
            height: 30px;

            .el-input-group__append,
            .el-input-group__prepend {
                padding: 0 10px;
                border: none;
            }

            .el-input__inner {
                height: 30px;
            }

            .icon-icon_sousuo {
                color: white;
            }
        }

        .add_btn {
            width: 100px;
            height: 30px;
            background: #5e75e6;
            color: white;
            outline: none;
            border: none;
        }

        //弹出框样式
        .el-dialog {
            width: 500px;

            .el-dialog__title {
                color: #5e75e6;
                font-size: 20px;
            }

            .el-dialog__close {
                font-size: 26px;
            }

            .el-dialog__body {
                padding-left: 0;
                padding-right: 0;
                padding-bottom: 0;
            }
        }
    }

    .key_list_wrap {
        height: 90%;

        .el-dialog {
            width: 600px;

            .el-dialog__title {
                color: #5e75e6;
                font-size: 20px;
            }

            .el-dialog__close {
                font-size: 26px;
            }

            .el-dialog__body {
                padding-left: 0;
                padding-right: 0;
                padding-bottom: 0;
            }
        }

        .footer_page {
            position: relative !important;
            margin-top: 20px;
            display: flex;
            justify-content: flex-end;
            margin-bottom: 20px;

            .el-pagination.is-background .el-pager li:not(.disabled).active {
                background-color: #5e75e6;
            }

            .el-pagination.is-background .btn-next,
            .el-pagination.is-background .btn-prev,
            .el-pagination.is-background .el-pager li {
                border: 1px solid #ccc;
                background: white;
            }
        }
    }
}
</style>
